import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {
    ICalendarDateItem,
    IDateRange,
    IDateRangeCalendarData,
} from '../interfaces/date-range.interfaces';

@Injectable({
    providedIn: 'root',
})
export class DateRangeService {
    /* События календаря */

    // Событие инициализации
    public CalendaryinitSubject = new Subject<IDateRangeCalendarData>();
    public CalendarySetParams(param: IDateRangeCalendarData) {
        // Установить параметры для календаря
        if (this.CalendaryinitSubject) {
            this.CalendaryinitSubject.next(param);
        }
    }

    public CalendaryonInit$(): Observable<IDateRangeCalendarData> {
        return this.CalendaryinitSubject.asObservable();
    }

    // Выбор дня в календаре
    public CalendarySelectDaySubject = new Subject<Date>();

    public CalendarySelectDay(param: Date) {
        // Установить параметры для календаря
        if (this.CalendarySelectDaySubject) {
            this.CalendarySelectDaySubject.next(param);
        }
    }

    public CalendaryOnSelectDay$(): Observable<Date> {
        return this.CalendarySelectDaySubject.asObservable();
    }

    // Установка дня в календаре
    public CalendarySetDateRangeSubject = new Subject<IDateRange>();

    public CalendarySetDateRange(param: IDateRange) {
        // Установить параметры для календаря
        if (this.CalendarySetDateRangeSubject) {
            this.CalendarySetDateRangeSubject.next(param);
        }
    }

    public CalendaryOnSetDateRange$(): Observable<IDateRange> {
        return this.CalendarySetDateRangeSubject.asObservable();
    }

    // Наведение на дату
    public CalendaryHoverDaySubject = new Subject<ICalendarDateItem>();
    public CalendaryHoverDay(param: ICalendarDateItem) {
        // Установить
        if (this.CalendaryHoverDaySubject) {
            this.CalendaryHoverDaySubject.next(param);
        }
    }

    public CalendaryOnHoverDay$(): Observable<ICalendarDateItem> {
        return this.CalendaryHoverDaySubject.asObservable();
    }

    public constructor() {}
}
